import { APIBase } from 'config/axiosBase';
import * as url from 'config/url_api';

const apiBase = new APIBase();

//system
export const getIP = () => apiBase.get(url.API_IP);
export const getFP = () => apiBase.get(url.API_FP);
export const getTime = () => apiBase.get(url.API_TIME);

//Auth
export const authSignIn = (data) => apiBase.post(url.API_AUTH_LOGIN, data);

//User
export const getByToken = () => apiBase.get(url.API_USERS_TOKEN);
export const checkByUserNameNew88 = (data) => apiBase.post(url.API_USERS_NEW88_CHECK, data);
export const checkByUserNameSHBET = (data) => apiBase.post(url.API_USERS_SHBET_CHECK, data);

//Match
export const createMatch = (data) => apiBase.post(url.API_MATCHS, data);
export const getPagingMatch = (data) => apiBase.get(`${url.API_MATCHS}${data && `?${data}`}`, data);
export const deleteMatch = (id) => apiBase.delete(`${url.API_MATCHS}${id && `/${id}`}`);
export const getStartTimePredictions = (data) => apiBase.post(url.API_MATCHS_DATE, data);
export const getMatchByDate = (data) => apiBase.post(url.API_MATCHS_BY_DATE, data);
export const getMatchScheduleLS = (data) => apiBase.post(url.API_MATCH_SCHEDULE, data);
export const getMatchList = (data) => apiBase.post(url.API_MATCHS_LIST, data);
export const getMatchShowResult = (data) => apiBase.get(url.API_MATCHS_RESULT_LIST, data);
//Settings
export const getAllSetting = ({ site }) =>
  apiBase.get(url.API_SETTINGS, {
    params: { site }
  });

//Banner
export const getAllBanner = (data) => apiBase.get(`${url.API_BANNER}${data && `?${data}`}`);
//Files
export const getFiles = (params) => {
  return apiBase.get(url.API_FILES, {
    params: {
      site: params.site || 'jun88k36',
      shows: params.shows,
      type: params.type
    }
  });
};

//Banner - Updated to use new file API
export const getBanners = (site) => {
  return getFiles({
    site: site,
    shows: true,
    type: 'banner_bottom'
  });
};

//Get Right GIF
export const getRightGif = (site) => {
  return getFiles({
    site: site,
    shows: true,
    type: 'gif_right'
  });
};

//Predictions
export const createPredictions = (data) => apiBase.post(url.API_PREDICTIONS_MANY, data);
export const historyPredictions = (data) => apiBase.post(url.API_PREDICTIONS_GET, data);

export const claimReward = async (data) => {
  try {
    const response = await apiBase.post(url.API_PREDICTIONS_CLAIM_REWARD, data);
    if (response && response.code === 0) {
      return response;
    }
    throw new Error(response?.text_mess || response?.message || 'Nhận thưởng thất bại!');
  } catch (error) {
    console.error('Claim reward error:', error);
    throw new Error(
      error.response?.data?.text_mess || error.response?.data?.title_mess || error.message
    );
  }
};

export const claimWorldCupReward = async (data) => {
  try {
    const response = await apiBase.post(url.API_WORLDCUP_CLAIM_REWARD, data);
    if (response && response.code === 0) {
      return response;
    }
    throw new Error(response?.text_mess || response?.message || 'Nhận thưởng thất bại!');
  } catch (error) {
    console.error('Claim World Cup reward error:', error);
    throw new Error(
      error.response?.data?.text_mess || error.response?.data?.title_mess || error.message
    );
  }
};

export const predictChampion = (data) => apiBase.post(url.API_WORLDCUP_CHAMPION, data);
export const predictTopScorer = (data) => apiBase.post(url.API_WORLDCUP_TOP_SCORER, data);
export const predictFinalAsiaTeam = (data) =>
  apiBase.post(url.API_WORLDCUP_FINAL_ASIA_TEAM, data);
/** Thống kê dự đoán đội vô địch (BXH %) */
export const getWorldCupChampionStats = () => apiBase.get(url.API_WORLDCUP_TEAMS_CHAMPIONS);
/** Thống kê dự đoán đội châu Á vào sâu nhất (top %) */
export const getWorldCupFinalAsiaTeamStats = () => apiBase.get(url.API_WORLDCUP_FINAL_ASIA_TEAM);
/** Thống kê dự đoán vua phá lưới (top %) */
export const getWorldCupTopScorerStats = () => apiBase.get(url.API_WORLDCUP_TOP_SCORERS);
/** Danh sách đội (catalog chọn đội) */
export const getWorldCupTeamsList = () => apiBase.get(url.API_WORLDCUP_TEAMS);
/** Danh sách đội châu Á (catalog) */
export const getWorldCupTeamsAsiaList = () => apiBase.get(url.API_WORLDCUP_TEAMS_ASIA);
/** Danh sách cầu thủ (catalog) */
export const getWorldCupPlayersList = () => apiBase.get(url.API_WORLDCUP_PLAYERS);
export const getTeams = getWorldCupChampionStats;
export const getPlayers = getWorldCupTopScorerStats;
